import { useEffect, useCallback } from 'react';
import { useNavigate, useRouter, useSearch } from '@tanstack/react-router';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  returnToPath: string;
  splashScreen: React.ReactNode;
};

type ContainerProps = {
  children: React.ReactNode;
  returnToPath: string;
};

export default function GuestGuard({ children, returnToPath, splashScreen }: Props) {
  const { loading } = useAuthContext();

  return (
    <>{loading ? splashScreen : <Container returnToPath={returnToPath}>{children}</Container>}</>
  );
}

// ----------------------------------------------------------------------

function Container({ children, returnToPath }: ContainerProps) {
  const router = useRouter();
  const navigate = useCallback((to: any) => router.navigate({ to }), [router]);

  const { authenticated } = useAuthContext();

  const check = useCallback(() => {
    if (authenticated) {
      navigate(returnToPath);
    }
  }, [authenticated, navigate, returnToPath]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
